import type { ParsedIconMarkup } from './types'

const OPENING_TAG = /^<svg\b([^>]*)>/
const ATTRIBUTE = /([a-zA-Z-]+)\s*=\s*(["'])(.*?)\2/g

export const parseIconMarkup = (markup: string): ParsedIconMarkup | null => {
    const trimmed = markup.trim()
    const opening = trimmed.match(OPENING_TAG)
    const close = trimmed.lastIndexOf('</svg>')
    if (!opening || close === -1) {
        return null
    }
    const attributes: Record<string, string> = {}
    for (const match of opening[1].matchAll(ATTRIBUTE)) {
        attributes[match[1]] = match[3]
    }
    const rootPaint: ParsedIconMarkup['rootPaint'] = {}
    if (attributes.fill !== undefined) {
        rootPaint.fill = attributes.fill
    }
    if (attributes.stroke !== undefined) {
        rootPaint.stroke = attributes.stroke
    }
    const intrinsic: ParsedIconMarkup['intrinsic'] = {}
    if (attributes.width !== undefined) {
        intrinsic.width = attributes.width
    }
    if (attributes.height !== undefined) {
        intrinsic.height = attributes.height
    }
    return {
        viewBox: attributes.viewBox ?? '0 0 24 24',
        inner: trimmed.slice(opening[0].length, close),
        rootPaint,
        intrinsic,
    }
}
